<template>
    <router-view />
</template>

<script>
export default {
  name : 'ServerBase',
}
</script>
